import React, { useMemo } from "react";
import { CitedExcerpt } from "../cited-excerpt";
import { Citation } from "../../helpers/Models";
import ScrollToBottom from "react-scroll-to-bottom";
import { twMerge } from "tailwind-merge";
import { Tabs } from ".";
import { Message } from "ai";
import { ChatMessage } from "./chat-message";
import TypingIndicator from "../markdown/TypingIndicator";
import { useOpinionPlainText } from "../../hooks/use-opinion-plain-text";
import { markTextSentences } from "../../helpers/chat-helpers";
import { isRunningInBrowser } from "../App";
import { ShortSummaryContainer } from "../short-summary";

interface CollapseGroupProps {
  citation: Citation;
  messages: Message[];
  isLoading: boolean;
  isStreaming: boolean;
  activeTab?: Tabs;
}

const CollapseGroup: React.FC<CollapseGroupProps> = ({ citation, messages, isLoading, activeTab, isStreaming }) => {
  const { opinionPlainText } = useOpinionPlainText({ opinionId: citation.opinion_id ?? "" });
  const { sentences: opinionSentences } = useMemo(() => {
    return markTextSentences(opinionPlainText ?? "");
  }, [opinionPlainText]);

  return (
    <div className="flex-1 overflow-y-scroll">
      <div className={`${activeTab === Tabs.citedExcerpt ? "block" : "hidden"} py-[10px]`}>
        <CitedExcerpt citation={citation} activeTab={activeTab} />
      </div>
      <ScrollToBottom initialScrollBehavior="auto">
        <div className={twMerge("", activeTab === Tabs.chat ? "block" : "hidden")}>
          {messages?.map((message, index) => (
            <ChatMessage
              message={message}
              key={index}
              opinionId={citation.opinion_id ?? ""}
              caseName={citation.case_name ?? null}
              isLastMessage={index === messages.length - 1}
              opinionSentences={opinionSentences}
              isStreaming={isStreaming}
            />
          ))}
          {isLoading && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <TypingIndicator />
            </div>
          )}
          {isRunningInBrowser() && <ShortSummaryContainer opinionId={citation.opinion_id} />}
        </div>
      </ScrollToBottom>
    </div>
  );
};

export default CollapseGroup;
